<template>
	<div class="page-in">
		<div class="inside-page">
			<div class="layui-container" v-if="goods">
				<div class="brread-box">
					<el-breadcrumb separator="/">
					  <el-breadcrumb-item :to="{ path: '/' }">{{$t('主页')}}</el-breadcrumb-item>
					  <el-breadcrumb-item>{{$t(goods.title)}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="detail-main" >
					<div class="detail-swiper">
						<div class="detail-swiper-photo"><img :src="goods.img[0]" alt="" /></div>
					</div>
					<div class="detail-col detail-comment-col">
						<div class="detail-head">
							<div class="flex-col">
								<div class="title">
									{{goods.title}}
								</div>
							</div>
						</div>
						<div class="detail-price">
							{{goods.price}} VND
						</div>
						<div class="sku-cell">
							<div class="sku-label">{{$t('规格')}}：</div>
							<div class="flex-col">
								{{goods.spec}}
							</div>
						</div>
						<div class="sku-comment">
							<div class="sku-comment-label">{{$t('商品评价')}}</div>
							<div class="sku-comment-score">
								<div class="s-label">{{$t('商品评分')}}:</div>
								<div class="sku-score">
									<el-rate v-model="comment.star" :colors="colors" text-color="#FC686F"
										score-template="{value}">
									</el-rate>
								</div>
							</div>
							<div class="sku-comment-score">
								<div class="s-label">{{$t('评价等级')}}:</div>
								<div class="sku-icon-score">
									<div class="col" v-for="(item,index) in iconClasses" :key="index"
										:class="{ active: comment.level === item.level }">
										<el-tooltip class="item" effect="dark" :content="item.text" placement="top">
											<span class="iconfont" :class="item.icon"
												@click="onLevel(item.level)"></span>
										</el-tooltip>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="comment-panel">
					<div class="comment-form">
						<div class="comment-form_hd">{{$t('填写您的购物体验吧')}}</div>
						<div class="layui-form" action="">
							<div class="comment-form_textarea">
								<el-input type="textarea" v-model="comment.content" :placeholder="$t('请在这里填写评价')"
									rows="8"></el-input>
							</div>
							<div class="comment-form_row ">
								<div class="comment-form_label">{{$t('上传图片')}}</div>
								<div class="flex-col">
									<div class="comment-upload-cell">
										<el-upload 
										    class="avatar-uploader" 
										    :action="rootUrl + '/upload/upload'"
											:limit="5"
										    list-type="picture-card"
										    :file-list="fileList"
										    :on-success="handleAvatarSuccess" 
										    :on-remove="handleRemove"
											:on-exceed="handleExceed"
										    :headers="uploadHeader">
										    <i slot="default" class="el-icon-plus"></i>
										</el-upload>
									</div>
								</div>
							</div>
							
							<div class="comment-form-button">
								<button class="layui-btn layui-btn-normal" @click="getProductComment">{{$t('提交评价')}}</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		index_goods_detail_api,
		index_goods_list_api
	} from "@/api/index"
	import {
		order_comment_api,
		user_upload_api
	} from "@/api/user"
	import helper from '@/common/helper.js';
	import Cooperation from '../Home/components/Cooperation.vue'
	import Recommend from '@/components/Recommend.vue'
	import Comments from '@/components/Comments.vue'
	export default {
		components: {
			Cooperation,
			Comments,
			Recommend
		},
		data() {
			return {
				colors: ['#FC686F', '#FC686F', '#FC686F'],
				goods: null,
				fileList: [],
				comment: {
					orderid: '',
					gid: '',
					content: '',
					pic: '',
					star: 5,
					level: 1,
				},
				iconClasses: [{
					text: this.$t('差评'),
					icon: 'icon-chaping',
					level: 3
				}, {
					text: this.$t('中评'),
					icon: 'icon-zhongping',
					level: 2
				}, {
					text: this.$t('好评'),
					icon: 'icon-haoping',
					level: 1
				}, ],
				uploadHeader: {
					'api-login-token': '',
					'api-login-key': ''
				},
				rootUrl: process.env.VUE_APP_API_BASE_URL,
			};
		},
		methods: {
			handleAvatarSuccess(e,file) {
			    if (e.code == 1) {
			        // 将新上传的图片添加到 fileList 中
			        this.fileList.push({
			            url: e.data, // 假设 e.data 是上传成功后返回的图片 URL
			            response: e // 
			        });
			        if (!this.comment.pic) {
			            this.comment.pic = e.data;
			        } else {
			            let currentPics = this.comment.pic.split(',');
			            currentPics.push(e.data); // 添加新图片
			            // 限制最多 5 张图片
			            if (currentPics.length > 5) {
			                this.errorTips('最多只能上传 5 张图片');
			                currentPics = currentPics.slice(0, 5); // 只保留前 5 张
			            }
			            this.comment.pic = currentPics.join(','); // 重新赋值为逗号分隔的字符串
			        }
			    }
			    console.log(this.comment.pic, 'this.comment.pic');
			},
			handleExceed(files, fileList) {
				this.errorTips('最多只能上传 5 张图片');
			  },
			handleAvatarchange(file, fileList) {
			    if (fileList.length > 5) {
			        this.errorTips('最多只能上传 5 张图片');
			        fileList.pop();
					return false
			    }
			},
			beforeAvatarUpload(file) {
				if (this.fileList.length > 5) {
				    this.errorTips('最多只能上传 5 张图片');
					return false
				}
			  },
			handleRemove(file) {
			    // 从 comment.pic 中移除被删除的图片
			    let currentPics = this.comment.pic.split(',');
			    currentPics = currentPics.filter(pic => pic !== file.url); // 过滤掉被删除的图片
			    this.comment.pic = currentPics.join(','); // 更新 comment.pic
			
			    // 从 fileList 中移除已删除的文件
			    const index = this.fileList.findIndex(item => item.url === file.url);
			    if (index !== -1) {
			        this.fileList.splice(index, 1);
			    }
			},
			onLevel(level) {
				this.comment.level = level
			},
			async getProductData() {
				let param = {
					id: this.comment.gid
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await index_goods_detail_api(param).then(res => {
					if (res && res.data.code == 1) {
						this.goods = res.data.data.goods
					}
					loading.close()
				});
			},
			async getProductComment() {
				if (this.comment.content == "") {
					this.errorTips("请输入评价内容");
					return false;
				}
				let param = {
					id: this.comment.orderid,
					content: this.comment.content,
					pic: this.comment.pic,
					star: this.comment.star,
					level: this.comment.level,
				}
				const loading = this.$loading({
					lock: true,
					text: '',
					spinner: 'loader',
					background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_comment_api(param).then(res => {
					if (res && res.data.code == 1) {
						this.successTips('评价成功')
						this.goUrl('/my-order')
					} else {
						this.errorTips(res.data.msg)
					}
					loading.close()
				});
			},
		},
		mounted() {
			const aid = this.$route.query.aid;
			const gid = this.$route.query.gid;
			if (aid && gid) {
				this.comment.orderid = this.$route.query.aid
				this.comment.gid = this.$route.query.gid
				this.getProductData()
			}
			let {token,token_key} = helper.get("tokenInfo");
			this.uploadHeader['api-login-token'] = token;
			this.uploadHeader['api-login-key'] = token_key;

		}
	}
</script>